class StartupUserInterface {

  constructor(apiClient, startupId, userId) {

    this.apiClient = apiClient;
    this.startupId = startupId;
    this.basePath = `/startups/${startupId}/users/${userId}`;

  }

  async getPermissionsByUserId() {

    const path = this.basePath + '/permissions';

    return this.apiClient.get(path);

  }

  async getProfile() {

    const path = this.basePath + '/basic-profile';

    return this.apiClient.get(path);

  }

  async getPermissionNamesByStartupUserId() {

    const path = this.basePath + '/permissions';

    return this.apiClient.get(path);

  }

  async updateUserProfilePictureById(file) {

    const path = this.basePath + '/profile-picture';

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.put(path, {}, {}, data, true);
  }

  async updateUserProfileById(data) {

    const path = this.basePath + '/basic-profile';

    return this.apiClient.put(path, {}, {}, data);
  }

  async validateUpdateUserProfileByIdInput(data) {

    const path = this.basePath + '/basic-profile/validate';

    return this.apiClient.put(path, {}, {}, data);

  }

  async getMenuListByStartupUserId() {

    const path = this.basePath + '/menu-list';

    return this.apiClient.get(path);

  }

  async tryConnectStartupUserAndObserver(userObserverId = 'unknown') {

    const path = this.basePath + '/connect-to-user-observer/:userObserverId';

    return this.apiClient.put(path, { userObserverId }, {}, {});

  }

  async updateCodeForReferralsByStartupUserId(codeForReferrals) {

    const path = `${this.basePath}/code-for-referrals`;

    return this.apiClient.put(path, {}, {}, { codeForReferrals });

  }

  async isConnectedToGoogleCalendar() {

    const path = this.basePath + '/is-connected-to-google-calendar';

    return this.apiClient.get(path);

  }

  async tryConnectToGoogleCalendar(data) {

    const path = this.basePath + '/connect-to-google-calendar';

    return this.apiClient.put(path, {}, {}, data);

  }

}

export default StartupUserInterface;